namespace $.$$ {
	$mol_style_define($easyreels_user_upload, {
		flex: {
			direction: 'column',
		},
		gap: $mol_gap.block,
		Bar: {
			alignSelf: 'stretch',
		},
		Detail: {
			font: {
				size: '.8rem',
			},
			opacity: .7,
		},
		Pick: {
			position: 'relative',
			overflow: 'hidden',
		},
	})
}
